<template>

  <div class="article-list">
    <div class="hero-post" v-if="heroPost">
      <div class="wrap-black banner-with-copy">
        <div class="row">
          <div class="col-xs-12 col-md-6" v-if="heroImg">
            <div class="pic" :style="'background-image:url(' + heroImg + ');'">
              <router-link :to="{name: 'blog-article', params: {id: heroPost.id}}">
              </router-link>
              <div class="overlay"></div>
            </div>
          </div>
          <div class="col-xs-12 banner-content-wrap" :class="heroImg ? 'col-sm-6' : ''">
            <div class="banner-copy">
              <h1><router-link :to="{name: 'blog-article', params: {id: heroPost.id}}">{{heroPost.title}}</router-link></h1>
              <p>
                {{heroContent}}
              </p>
              <router-link :to="{name: 'blog-article', params: {id: heroPost.id}}" class="btn-pub btn-pub-blank fixed-width xs-full-width">
                Read More</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid sub-articles">
      <div class="row">
        <BlogListArticle v-for="article in showList" :article="article"></BlogListArticle>
      </div>
    </div>

    <div class="text-center" v-if="showList.length < blogPosts.length">
      <button class="btn-pub btn-pub-blank" v-on:click="loadMore()" v-if="">Load More Articles</button>
    </div>
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import BlogListArticle from './BlogListArticle'
  import _ from 'underscore'



  export default {
    components: {
      BlogListArticle
    },

    created() {
      this.$store.dispatch('getBlogPosts');
    },

    methods: {
      loadMore() {
        this.showCount += 10;
      },
    },

    computed: {
      ...mapState([
      ]),

      heroPost() {
        let posts = this.blogPosts;
        if (posts.length > 0) {
          return posts[0];
        } else {
          return null;
        }
      },
      heroImg() {
        if (!this.heroPost || this.heroPost.blog_images.length <= 0) { return null }
        else {
          return this.heroPost.blog_images[0].image_url;
        }
      },
      heroContent() {
        if (!this.heroPost) { return '' }
        else {
          const html = this.heroPost.content;
          let div = document.createElement("div");
          div.innerHTML = html;
          let text = div.textContent || div.innerText || "";
          return text;
        }
      },
      blogPosts() {
        const posts = this.$store.getters.allBlogPosts;
        return posts;
      },

      showList() {
        return this.blogPosts.slice(1, this.showCount);
      }
    },

    data() {
      return {
        showCount: 10,
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .hero-post h1 a {color:#FFFFFF;font-size:60px;}
  .hero-post p {max-height:202px;overflow:hidden;font-size:30px;line-height:34px;}
  .hero-post .pic { width: 100%; padding-top: 100%; position: relative;overflow:hidden; background-size:cover;background-repeat:no-repeat;background-position:center;}
  .hero-post .pic a {position:absolute;top:0px;left:0px;width:100%;height:100%;}

  .sub-articles {max-width:1600px;margin:100px auto 0px auto;}

  @media only screen and (max-width:1400px) {
    .hero-post p { max-height: 204px;}
    }
  @media only screen and (max-width:1100px) {
    .hero-post p { max-height: 140px;font-size:24px;line-height:28px;}
  }

  @media only screen and (max-width:700px) {
    .hero-post h1 {max-height:70px;overflow:hidden;}
    .hero-post h1 a { font-size: 30px;line-height:35px;}
    .hero-post p { max-height: 112px; font-size: 18px; line-height: 22px; margin-bottom:20px;margin-top:20px;}
  }
</style>



// WEBPACK FOOTER //
// BlogList.vue?ec93438c